import { restrictions } from 'state/features-list/constants';

export const PAGE_SIZE = 20;

export const SearchTypes = {
  PERKS: 'perks',
  POSTS: 'posts',
  SUPPORT: 'library',
};

export const SEARCH_RESTRICTIONS = [
  restrictions['eap_assistance'],
  restrictions['eap_hwr_toolkits'],
  restrictions['benefit_online_shop'],
  restrictions['benefit_restaurant'],
  restrictions['benefit_cinema'],
  restrictions['benefit_colleague_offer'],
  restrictions['benefit_global_gift_cards'],
  restrictions['benefit_in_store_offer'],
  restrictions['social_feed'],
];
